{
    "name": "app",
    "version": "1.0.13",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --port 1212",
        "startIP": "ng serve --host 192.168.1.67 --port 1212",
        "build": "ng build",
        "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools && npm run i18n:extract:form && npm run i18n:extract:law-baner && npm run i18n:extract:footer && npm run i18n:extract:reply && npm run i18n:extract:avatar",
        "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:form": "ngx-translate-extract -i ./src/sb-modules/Frontend-form-field-module -o ./src/sb-modules/Frontend-form-field-module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:law-baner": "ngx-translate-extract -i ./src/sb-modules/Frontend-Cookie-Law-Banner-Module -o ./src/sb-modules/Frontend-Cookie-Law-Banner-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:footer": "ngx-translate-extract -i ./src/sb-modules/Frontend-Footer-Module -o ./src/sb-modules/Frontend-Footer-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:reply": "ngx-translate-extract -i ./src/sb-modules/Frontend-Reply-Templates-Module -o ./src/sb-modules/Frontend-Reply-Templates-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:avatar": "ngx-translate-extract -i ./src/sb-modules/Frontend-User-Avatar-Module -o ./src/sb-modules/Frontend-User-Avatar-Module/assets/i18n/en.json --sort -f json --clean",
        "prepare": "husky install",
        "prettier": "npx prettier --write .",
        "serve:ssr": "node dist/app/server/server.mjs",
        "postinstall": "patch-package"
    },
    "private": true,
    "dependencies": {
        "@ali-hm/angular-tree-component": "^12.0.5",
        "@angular-devkit/build-angular": "^20.3.1",
        "@angular/animations": "^20.3.0",
        "@angular/cli": "^20.3.1",
        "@angular/common": "^20.3.0",
        "@angular/compiler": "^20.3.0",
        "@angular/compiler-cli": "^20.3.0",
        "@angular/core": "^20.3.0",
        "@angular/forms": "^20.3.0",
        "@angular/platform-browser": "^20.3.0",
        "@angular/platform-browser-dynamic": "^20.3.0",
        "@angular/platform-server": "^20.3.0",
        "@angular/router": "^20.3.0",
        "@angular/ssr": "^20.3.1",
        "@ctrl/ngx-emoji-mart": "^9.3.0",
        "@microsoft/applicationinsights-web": "^2.8.9",
        "@ng-select/ng-select": "^14.9.0",
        "@ngx-translate/core": "^14.0.0",
        "@types/jquery": "^3.5.16",
        "angular2-notifications": "^16.0.1",
        "autolinker": "^4.1.5",
        "domino": "^2.1.6",
        "eslint-config-prettier": "^9.0.0",
        "eslint-plugin-prettier": "^5.0.1",
        "express": "^5.1.0",
        "intl-tel-input": "^25.11.2",
        "jquery": "^3.6.3",
        "ngx-avatars": "^1.8.0",
        "ngx-bootstrap": "^18.0.0",
        "ngx-dropzone-wrapper": "^13.0.0",
        "ngx-linky": "^4.0.0",
        "ngx-quill": "^26.0.10",
        "ngx-summernote": "^1.0.0",
        "ngx-translate-multi-http-loader": "^9.3.0",
        "prettier": "^3.0.3",
        "prettier-eslint": "^16.1.2",
        "quill": "2.0.2",
        "quill-image-resize": "^3.0.9",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.1",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-eslint/builder": "20.3.0",
        "@angular-eslint/eslint-plugin": "20.3.0",
        "@angular-eslint/eslint-plugin-template": "20.3.0",
        "@angular-eslint/schematics": "20.3.0",
        "@angular-eslint/template-parser": "20.3.0",
        "@types/express": "^5.0.1",
        "@types/jasmine": "~4.3.1",
        "@types/jest": "^30.0.0",
        "@types/node": "^24.5.0",
        "@typescript-eslint/eslint-plugin": "^7.2.0",
        "@typescript-eslint/parser": "^7.2.0",
        "@vendure/ngx-translate-extract": "^10.1.3",
        "browser-sync": "^3.0.0",
        "cross-env": "^7.0.3",
        "deepmerge-ts": "^4.2.2",
        "eslint": "^8.57.0",
        "eslint-plugin-import": "^2.27.4",
        "eslint-plugin-jasmine": "^4.2.2",
        "eslint-plugin-jsdoc": "^39.6.4",
        "husky": "^8.0.3",
        "jasmine-core": "~4.5.0",
        "jasmine-spec-reporter": "^7.0.0",
        "karma": "~6.4.1",
        "karma-chrome-launcher": "~3.1.1",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.0.0",
        "patch-package": "^8.0.1",
        "postinstall-postinstall": "^2.1.0",
        "protractor": "^7.0.0",
        "ts-node": "~10.9.1",
        "typescript": "^5.8.3",
        "xmlhttprequest": "^1.8.0"
    }
}
